import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import { getChartValueColor } from '../../../../../../utils/chart';
import createTooltipMarkup from '../components/h2h-tooltip/tooltipMarkup';
import { BACKGROUND_COLORS } from '../../concept-compare-section/charts/useConceptDatasets';

const useH2HConceptChartData = (h2hConcept, isGlobalPercentage) => {
  const theme = useSelector((state) => state.global.theme);

  const validSubconcepts = useMemo(
    () => h2hConcept?.subconcepts.filter((subConcept) => !!subConcept.subheader),
    [h2hConcept?.subconcepts],
  );

  const chartLabels = useMemo(() => validSubconcepts.map((subConcept) => subConcept.subheader), [validSubconcepts]);

  const datasets = useMemo(() => {
    return [
      {
        label: h2hConcept.header,
        data: validSubconcepts.map((subConcept) => (isGlobalPercentage ? subConcept.globalTotal : subConcept.total)),
        backgroundColor: BACKGROUND_COLORS,
        borderWidth: 0,
        borderRadius: 8,
        pointStyle: false,
      },
    ];
  }, [h2hConcept?.header, validSubconcepts, isGlobalPercentage]);

  const chartsConfig = useMemo(() => {
    return {
      options: {
        plugins: {
          legend: {
            display: true,
            labels: {
              color: getChartValueColor(theme),
              font: {
                size: 14,
              },
            },
          },
        },
      },
      tooltip: {
        createMarkup: (tooltipModel) => createTooltipMarkup({ tooltipModel }),
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        color: getChartValueColor(theme),
        font: {
          size: '12px',
          weight: 'bold',
          family: 'Inter',
        },
        formatter: function (value) {
          return value ? value + '%' : '';
        },
      },
      scales: {
        x: {
          ticks: {
            display: false,
          },
        },
      },
    };
  }, [theme]);

  return {
    chartLabels,
    datasets,
    chartsConfig,
  };
};

export default useH2HConceptChartData;
